import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class MissingParameters extends Component {
  render() {
    const {
      missingParameters
    } = this.props;
    const count = missingParameters.length;
    return /*#__PURE__*/_jsxs(Alert, {
      titleText: I18n.text('oauth.missingParameters.title', {
        count
      }),
      type: "danger",
      marginBlockStart: "400",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "oauth.missingParameters.body",
        options: {
          count
        }
      }), /*#__PURE__*/_jsx(List, {
        styled: true,
        wrapChildren: true,
        children: missingParameters.map(parameter => {
          return /*#__PURE__*/_jsx("span", {
            children: parameter
          }, parameter);
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "oauth.missingParameters.contact"
      })]
    });
  }
}
MissingParameters.propTypes = {
  missingParameters: PropTypes.arrayOf(PropTypes.string).isRequired
};